(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      } 


      this.currentScrollTop = scrollTop;
    }

    hide() {
      /*this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();*/
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
        
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  function initialiseHeroSlider() {
    var heroSlider = document.querySelector(".hero-slider");
    if (!heroSlider || typeof window.Swiper !== "function") return;

    new Swiper(heroSlider.querySelector(".swiper"), {
    // spaceBetween: 50,
    // pagination: {
    //   el: ".swiper-pagination",
    //   clickable: true,
    // },
    observer: true,
    // autoheight: true,
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    // mousewheel: true,
    rewind: true,
    // loop: true,
    autoheight: true,
    speed: 2000,
    spaceBetween: 0,
    scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
          draggable: true,
    },
    autoplay: {
      delay: 6000,
      // disableOnInteraction: false,
      // pauseOnMouseEnter: true
    },
    keyboard: {
        enabled: true,
        onlyInViewport: false,
    },
    grabCursor: true
  });

    new Swiper(".mySwiper2", {
    // direction: "vertical",
    // spaceBetween: 50,
    // pagination: {
    //   el: ".swiper-pagination",
    //   clickable: true,
    // },
    observer: true,
    // keyboard: {
    //   enabled: true,
    //   onlyInViewport: false,
    // },
    // mousewheel: true,
    rewind: true,
    autoheight: true,
    effect: 'fade',
    // nested: true,
    autoplay: {
      delay: 2500,
      // disableOnInteraction: false,
      // pauseOnMouseEnter: true
    },
    speed: 2000,
    noSwiping: true,
    allowTouchMove: false
  });


  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialiseHeroSlider, { once: true });
  } else {
    initialiseHeroSlider();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!window.remassCollectionLoadMoreInitialised) {
    window.remassCollectionLoadMoreInitialised = true;

    let loadMoreObserver;
    let refreshScheduled = false;

    const historicalDateSort = {
      activeState: null,
      cache: new Map(),
      version: 0,

      isDateSort(sortBy) {
        return sortBy === 'created-ascending' || sortBy === 'created-descending';
      },

      itemDate(item) {
        const value = item.dataset.productEffectiveCreatedAt || item.dataset.productCreatedAt;
        const parsed = Date.parse(value || '');
        return Number.isNaN(parsed) ? 0 : parsed;
      },

      itemNativeDate(item) {
        const parsed = Date.parse(item.dataset.productCreatedAt || '');
        return Number.isNaN(parsed) ? 0 : parsed;
      },

      itemCollections(item) {
        try {
          const value = JSON.parse(item.dataset.originalCollectionHandles || '[]');
          return Array.isArray(value) ? value : [];
        } catch (error) {
          return [];
        }
      },

      sourceParams() {
        const params = new URLSearchParams();

        new URLSearchParams(window.location.search).forEach((value, key) => {
          if (key.startsWith('filter.')) params.append(key, value);
        });

        params.set('sort_by', 'title-ascending');
        params.set('page', '1');
        return params;
      },

      async fetchDocument(url) {
        const response = await fetch(url, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!response.ok) {
          throw new Error(`Historical date source request failed with status ${response.status}`);
        }

        return new DOMParser().parseFromString(await response.text(), 'text/html');
      },

      async sourceHtml(grid) {
        const sourceUrl = grid.dataset.historicalSortSourceUrl;
        const params = this.sourceParams();
        const cacheKey = `${sourceUrl}?${params.toString()}`;

        if (this.cache.has(cacheKey)) return this.cache.get(cacheKey);

        const firstUrl = `${sourceUrl}?${params.toString()}`;
        const firstDocument = await this.fetchDocument(firstUrl);
        const firstGrid = firstDocument.getElementById('product-grid');

        if (!firstGrid) {
          throw new Error('Historical date source did not contain a product grid');
        }

        const productCount = Number.parseInt(firstGrid.dataset.productCount || '0', 10);
        const productsPerPage = Number.parseInt(firstGrid.dataset.productsPerPage || '1', 10);
        const pageCount = Math.max(1, Math.ceil(productCount / Math.max(productsPerPage, 1)));
        const documents = [firstDocument];
        const sectionId = firstGrid.dataset.id;
        const pageRequests = [];

        for (let page = 2; page <= pageCount; page += 1) {
          const pageParams = new URLSearchParams(params);
          pageParams.set('section_id', sectionId);
          pageParams.set('page', String(page));
          pageRequests.push(this.fetchDocument(`${sourceUrl}?${pageParams.toString()}`));
        }

        documents.push(...(await Promise.all(pageRequests)));

        const items = documents.flatMap((documentNode) =>
          Array.from(
            documentNode.querySelectorAll('#product-grid > .grid__item__collection-product')
          )
        );
        const source = {
          allHtml: items.map((item) => item.outerHTML),
          migrationHtml: items
            .filter((item) => item.dataset.migrationProduct === 'true')
            .map((item) => item.outerHTML)
        };

        this.cache.set(cacheKey, source);
        return source;
      },

      createItem(html) {
        const template = document.createElement('template');
        template.innerHTML = html.trim();
        return template.content.firstElementChild;
      },

      sortItems(items, direction) {
        const multiplier = direction === 'ascending' ? 1 : -1;

        return items.sort((left, right) => {
          const dateDifference = this.itemDate(left) - this.itemDate(right);
          if (dateDifference !== 0) return dateDifference * multiplier;
          return (left.dataset.productId || '').localeCompare(right.dataset.productId || '') * multiplier;
        });
      },

      appendPage(items, hasNextPage) {
        const state = this.activeState;

        if (!state || !state.grid.isConnected) return null;

        const normalItems = [];

        items.forEach((item) => {
          const isReplacement = item.dataset.migrationProduct === 'true';
          const hasSourceReplacement = state.sourceProductIds.has(item.dataset.productId);

          if (!isReplacement || !hasSourceReplacement) normalItems.push(item);
        });

        let eligible = [];

        if (!hasNextPage) {
          eligible = state.pending.splice(0);
        } else if (normalItems.length) {
          const nativeDates = normalItems.map((item) => this.itemNativeDate(item));
          const boundary = state.direction === 'ascending'
            ? Math.max(...nativeDates)
            : Math.min(...nativeDates);

          eligible = state.pending.filter((item) => {
            const date = this.itemDate(item);
            return state.direction === 'ascending' ? date <= boundary : date >= boundary;
          });

          const eligibleIds = new Set(eligible.map((item) => item.dataset.productId));
          state.pending = state.pending.filter((item) => !eligibleIds.has(item.dataset.productId));
        }

        const combined = this.sortItems([...normalItems, ...eligible], state.direction);
        if (!state.rendered && !combined.length) return 0;

        if (!state.rendered) {
          state.grid.replaceChildren();
          state.rendered = true;
        }

        const fragment = document.createDocumentFragment();
        combined.forEach((item) => fragment.appendChild(item));
        state.grid.appendChild(fragment);
        return combined.length;
      },

      queueNextPage(button) {
        const state = this.activeState;

        if (!state || state.rendered || !button || !button.isConnected || !button.dataset.nextPageUrl) {
          return;
        }

        window.setTimeout(() => {
          if (
            state === this.activeState &&
            !state.rendered &&
            button.isConnected &&
            button.dataset.loading !== 'true' &&
            !button.disabled
          ) {
            button.click();
          }
        }, 0);
      },

      async initialise() {
        const grid = document.getElementById('product-grid');

        if (!grid || grid.dataset.historicalDateSortState) return;

        const sortBy = grid.dataset.sortBy;

        if (!this.isDateSort(sortBy)) {
          this.activeState = null;
          return;
        }

        const version = ++this.version;
        const direction = sortBy === 'created-ascending' ? 'ascending' : 'descending';
        const collectionHandle = grid.dataset.collectionHandle;
        const initialItems = Array.from(
          grid.querySelectorAll(':scope > .grid__item__collection-product')
        );
        const wrapper = grid.closest('.collection');
        const button = wrapper ? wrapper.querySelector('[data-load-more-button]') : null;
        const hasNextPage = Boolean(button && button.dataset.nextPageUrl);

        grid.dataset.historicalDateSortState = 'loading';
        grid.setAttribute('aria-busy', 'true');

        if (button) {
          button.dataset.historicalSortLoading = 'true';
          button.disabled = true;
        }

        try {
          const source = await this.sourceHtml(grid);
          const sourceItems = source.migrationHtml
            .map((html) => this.createItem(html))
            .filter((item) => item && this.itemCollections(item).includes(collectionHandle));

          if (version !== this.version || !grid.isConnected) return;

          if (collectionHandle === grid.dataset.historicalSortSourceHandle) {
            const allItems = source.allHtml
              .map((html) => this.createItem(html))
              .filter(Boolean);
            const fragment = document.createDocumentFragment();

            this.sortItems(allItems, direction).forEach((item) => fragment.appendChild(item));
            grid.replaceChildren(fragment);
            this.activeState = null;
            grid.dataset.historicalDateSortState = 'ready';

            const loadMore = wrapper ? wrapper.querySelector('.collection-load-more') : null;
            if (loadMore) loadMore.remove();
            return;
          }

          const sourceProductIds = new Set(sourceItems.map((item) => item.dataset.productId));
          this.activeState = {
            grid,
            direction,
            pending: this.sortItems(sourceItems, direction),
            sourceProductIds,
            rendered: false
          };

          this.appendPage(initialItems, hasNextPage);
          grid.dataset.historicalDateSortState = 'ready';
        } catch (error) {
          console.error('[Remass historical date sort]', error);
          grid.dataset.historicalDateSortState = 'failed';
          this.activeState = null;
        } finally {
          if (grid.isConnected) grid.removeAttribute('aria-busy');

          if (button && button.isConnected) {
            delete button.dataset.historicalSortLoading;
            button.disabled = false;
          }

          this.queueNextPage(button);
          scheduleRefresh();
        }
      }
    };

    const removeLegacyPagination = () => {
      document
        .querySelectorAll('.collection-grid-section .pagination-wrapper, #ProductGridContainer .pagination-wrapper')
        .forEach((pagination) => pagination.remove());
    };

    const observeLoadMoreButtons = () => {
      if (!('IntersectionObserver' in window)) return;

      if (!loadMoreObserver) {
        loadMoreObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              const button = entry.target;

              if (!button.isConnected) {
                loadMoreObserver.unobserve(button);
                return;
              }

              if (
                button.dataset.loading === 'true' ||
                button.dataset.autoLoadPaused === 'true' ||
                button.dataset.historicalSortLoading === 'true' ||
                button.disabled
              ) {
                return;
              }

              loadMoreObserver.unobserve(button);
              button.click();
            });
          },
          {
            root: null,
            rootMargin: '0px 0px 800px 0px',
            threshold: 0
          }
        );
      }

      document.querySelectorAll('[data-load-more-button]').forEach((button) => {
        if (
          !button.isConnected ||
          button.dataset.loading === 'true' ||
          button.dataset.autoLoadPaused === 'true' ||
          button.dataset.historicalSortLoading === 'true' ||
          button.disabled
        ) {
          return;
        }

        loadMoreObserver.observe(button);
      });
    };

    const refreshCollectionLoader = () => {
      removeLegacyPagination();
      historicalDateSort.initialise();
      observeLoadMoreButtons();
    };

    const scheduleRefresh = () => {
      if (refreshScheduled) return;

      refreshScheduled = true;

      window.requestAnimationFrame(() => {
        refreshScheduled = false;
        refreshCollectionLoader();
      });
    };

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-load-more-button]');

      if (
        !button ||
        button.dataset.loading === 'true' ||
        button.dataset.historicalSortLoading === 'true'
      ) {
        return;
      }

      const nextPageUrl = button.dataset.nextPageUrl;

      if (!nextPageUrl) return;

      const wrapper = button.closest('.collection-load-more');
      const status = wrapper ? wrapper.querySelector('[data-load-more-status]') : null;
      const productGrid = document.getElementById('product-grid');

      if (!productGrid) return;

      if (loadMoreObserver) loadMoreObserver.unobserve(button);

      button.dataset.autoLoadPaused = 'false';
      button.dataset.loading = 'true';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = button.dataset.loadingText;

      try {
        const response = await fetch(nextPageUrl, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!response.ok) {
          throw new Error(`Collection request failed with status ${response.status}`);
        }

        const responseText = await response.text();
        const nextDocument = new DOMParser().parseFromString(responseText, 'text/html');
        const newItems = Array.from(
          nextDocument.querySelectorAll('#product-grid > .grid__item__collection-product')
        );

        if (!newItems.length) {
          throw new Error('Collection response did not contain product cards');
        }

        if (!productGrid.isConnected) return;

        const nextButton = nextDocument.querySelector('[data-load-more-button]');
        const hasNextPage = Boolean(nextButton && nextButton.dataset.nextPageUrl);
        const historicallySortedCount = historicalDateSort.appendPage(newItems, hasNextPage);

        if (historicallySortedCount === null) {
          const fragment = document.createDocumentFragment();
          newItems.forEach((item) => fragment.appendChild(item));
          productGrid.appendChild(fragment);
        }

        if (status) {
          const visibleCount = historicallySortedCount === null ? newItems.length : historicallySortedCount;
          status.textContent = `${visibleCount} ${button.dataset.loadedText}`;
        }

        if (hasNextPage) {
          button.dataset.nextPageUrl = nextButton.dataset.nextPageUrl;
          button.disabled = false;
          button.textContent = button.dataset.defaultText;
        } else if (wrapper) {
          wrapper.remove();
        }
      } catch (error) {
        console.error('[Remass collection load more]', error);

        button.dataset.autoLoadPaused = 'true';
        button.disabled = false;
        button.textContent = button.dataset.defaultText;

        if (status) status.textContent = button.dataset.errorText;
      } finally {
        button.dataset.loading = 'false';
        button.removeAttribute('aria-busy');
        historicalDateSort.queueNextPage(button);
        scheduleRefresh();
      }
    });

    const collectionMutationObserver = new MutationObserver(() => {
      scheduleRefresh();
    });

    collectionMutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    refreshCollectionLoader();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-slider"] && !Shopify.designMode) return;
  try {
    
  function initialiseMultiSlider() {
    if (typeof window.Swiper !== "function") return;
    var swiper = new Swiper(".mySwiper", {
    // spaceBetween: 50,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    observer: true,
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    mousewheel: true,
    rewind: true,
    autoheight: true,
    speed: 400,
    // spaceBetween: 100,

  });
    new Swiper(".mySwiper2", {
    direction: "vertical",
    // spaceBetween: 50,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    observer: true,
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    mousewheel: true,
    rewind: true,
    autoheight: true,
    // speed: 400,
    spaceBetween: 100,
  });
  // const rotateButton = document.querySelector(".rotate-button");
  // rotateButton.addEventListener("click", () => {
  //   rotateButton.closest(".swiper-slide").classList.toggle("rotate");
  // });

    document.querySelectorAll(".icon-arrow-heart").forEach(element => {
      element.addEventListener("click", () => {
        swiper.slideNext(4000, true);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialiseMultiSlider, { once: true });
  } else {
    initialiseMultiSlider();
  }

  } catch(e) { console.error(e); }
})();
})();
